import { isMobile } from 'react-device-detect'

const size = {
  mobileS: '320px',
  mobileM: '375px',
  mobileL: '425px',
  tablet: '768px',
  laptop: '1024px',
  laptopM: '1366px',
  laptopL: '1439px',
  desktopM: '1920px',
  desktop: '2560px',
}

export const device = {
  desktopAll: `(min-width: ${size.laptop})`,
  mobileAll: `(max-width: ${size.tablet})`,
  mobileS: `(min-width: ${size.mobileS}) and (max-width: ${size.mobileM})`,
  mobileM: `(min-width: ${size.mobileM}) and (max-width: ${size.mobileL})`,
  mobileL: `(min-width: ${size.mobileL}) and (max-width: ${size.tablet})`,
  tablet: `(min-width: ${size.tablet}) and (max-width: ${size.laptop})`,
  laptop: `(min-width: ${size.laptop}) and (max-width: ${size.laptopM})`,
  laptopM: `(min-width: ${size.laptopM}) and (max-width: ${size.laptopL})`,
  laptopL: `(min-width: ${size.laptopL}) and (max-width: ${size.desktop - 1})`,
  desktopM: `(min-width: ${size.desktopM}) and (max-width: ${size.desktopL})`,
  ipad12: `only screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 2)`,
  ipad10: `only screen and (min-device-width: 834px) and (max-device-width: 1112px) and (-webkit-min-device-pixel-ratio: 2)`,
  ipad9: `only screen and (min-device-width: 768px) and (max-device-width: 1024px)  and (-webkit-min-device-pixel-ratio: 2)`,
  oldIpads: `only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1)`,
  desktopL: `(min-width: 2560px)`,
  ipad12: `only screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 2)`,
  ipad10: `only screen and (min-device-width: 834px) and (max-device-width: 1112px) and (-webkit-min-device-pixel-ratio: 2)`,
  ipad9: `only screen and (min-device-width: 768px) and (max-device-width: 1024px)  and (-webkit-min-device-pixel-ratio: 2)`,
  oldIpads: `only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1)`,
}

export function mediaQ(media, setting) {
  let mediaquer
  switch (media) {
    case 'desktopAll':
      mediaquer = `@media ${device.desktopAll}{${setting}}`
      break
    case 'mobileAll':
      mediaquer = `@media ${device.mobileAll}{${setting}}`
      break
    case 'mobileS':
      mediaquer = `@media ${device.mobileS}{${setting}}`
      break
    case 'mobileM':
      mediaquer = `@media ${device.mobileM}{${setting}}`
      break
    case 'mobileL':
      mediaquer = `@media ${device.mobileM}{${setting}}`
      break
    case 'tablet':
      mediaquer = `@media ${device.tablet}{${setting}}`
      break
    case 'laptop':
      mediaquer = `@media ${device.laptop}{${setting}}`
      break
    case 'laptopM':
      mediaquer = `@media ${device.laptopM}{${setting}}`
      break
    case 'laptopL':
      mediaquer = `@media ${device.laptopL}{${setting}}`
      break
    case 'desktopM':
      mediaquer = `@media ${device.desktopM}{${setting}}`
      break
    case 'desktopL':
      mediaquer = `@media ${device.desktopL}{${setting}}`
      break
    case 'ipad12':
      mediaquer = `@media ${device.ipad12}{${setting}}`
      break
    case 'ipad10':
      mediaquer = `@media ${device.ipad10}{${setting}}`
      break
    case 'ipad9':
      mediaquer = `@media ${device.ipad9}{${setting}}`
      break
    case 'oldIpads':
      mediaquer = `@media ${device.oldIpads}{${setting}}`
      break
    default:
      break
  }
  return mediaquer
}

export function fontSizeResponsive(fontSize) {
  // DESKTOPS
  return `@media (min-width: 2560px){
    font-size:${Math.ceil(fontSize * 1.2)}px;
  };
  @media (min-width: 1920px) and (max-width: 2559px ){
    font-size:${fontSize}px;
  };
  @media (min-width: 1599px) and (max-width: 1919px ){
    font-size:${Math.ceil(fontSize * 0.78)}px;
  };
  @media (min-width: 1367px) and (max-width: 1598px ){
    font-size:${Math.ceil(fontSize * 0.7)}px;
  };
  @media (min-width: 1366px) and (max-width: 1438px ){
    font-size:${Math.ceil(fontSize * 0.7)}px;
  };
  @media (min-width: 1280px) and (max-width: 1365px ){
    font-size:${Math.ceil(fontSize * 0.58)}px;
  };
  @media (min-width: 1024px) and (max-width: 1279px ){
    font-size:${Math.ceil(fontSize * 0.5)}px;
  };
  @media (min-width: 768px) and (max-width: 1023px ){
    font-size:${Math.ceil(fontSize * 0.6)}px;
  };

  @media only screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 2){
    font-size:${Math.ceil(fontSize * 0.9)}px;
  }
  @media only screen and (min-device-width: 834px) and (max-device-width: 1112px) and (-webkit-min-device-pixel-ratio: 2){
  font-size:${Math.ceil(fontSize * 0.9)}px;
  }
  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px)  and (-webkit-min-device-pixel-ratio: 2){
    font-size:${Math.ceil(fontSize * 0.9)}px;
  }

  @media (min-width: 381px) and (max-width: 767px ){
    font-size:${Math.ceil(fontSize * 0.6)}px;
  };
  @media (min-width: 360px) and (max-width: 480px ){
    font-size:${Math.ceil(fontSize * 0.6)}px;
  };
  @media (min-width: 320px) and (max-width: 359px ){
    font-size:${Math.ceil(fontSize * 0.3)}px;
  }`
}

export function manageMask(image, position) {
  let mask = ''
  if (image === 'main' && position === 'left') {
    mask = `linear-gradient(90deg, rgba(239,239,239,1) 0%, rgba(255,255,255,0) 42%)`
  } else if (image === 'main' && position === 'right') {
    mask = `linear-gradient(90deg, rgba(255,255,255,0) 58%, rgba(239,239,239,1) 100%);`
  } else if (image === 'left' && position === 'center') {
    mask = `linear-gradient(90deg, rgba(255,255,255,0) 58%, rgba(239,239,239,1) 100%);`
  } else if (image === 'right' && position === 'center') {
    mask = `linear-gradient(90deg, rgba(239,239,239,1) 0%, rgba(255,255,255,0) 42%)`
  }

  return mask
}

export const customModalStyles = {
  overlay: { zIndex: 1000, backgroundColor: `rgba(0, 0, 0, 0.5)` },
  content: {
    // zIndex: '15',
    right: `unset`,
    bottom: `unset`,
    top: !isMobile ? `50%` : `0%`,
    left: !isMobile ? `50%` : `0%`,
    transform: !isMobile ? `translate(-50%, -50%)` : `translate(0%, 0%)`,
    padding: `10px 15px`,
    minWidth: !isMobile ? `400px` : 'unset',
    // maxHeight: '50%',
    height: isMobile ? '100%' : 'unset',
    width: isMobile ? '92%' : '550px',
  },
}

export const scrollFixer = () => {
  const windowWidth = window.innerWidth
  let fixer = 0

  if (windowWidth > 1100 && windowWidth < 1300) {
    fixer = 500
  } else if (windowWidth > 1300 && windowWidth < 1400) {
    fixer = 300
  } else if (windowWidth > 1400 && windowWidth < 1700) {
    fixer = 200
  } else if (windowWidth > 1700) {
    fixer = 100
  }

  return fixer
}

export const compareBackgroundSelector = (mode, backgroundSrc) => {
  let background = ``
  switch (mode) {
    case 'sideStart':
      background = `url(${backgroundSrc})`
      return background
    case 'sideCurrent':
      background = `url(${backgroundSrc})`
      return background

    default:
      break
  }
}

export const manageMobileGallery = (imagePosition, currentImage) => {
  let mobileQuery = ``
  switch (currentImage) {
    case 'left':
      if (imagePosition === 'left') {
        mobileQuery = `@media (max-width: 600px) {
          width: 70vw;
        }`
      }
      if (imagePosition === 'center') {
        mobileQuery = `@media (max-width: 600px) {
            width: 15vw;
          }`
      }
      return mobileQuery

    case 'center':
      if (imagePosition === 'left') {
        mobileQuery = `@media (max-width: 600px) {
          width: 15vw;
        }`
      }
      if (imagePosition === 'center') {
        mobileQuery = `@media (max-width: 600px) {
            width: 70vw;
          }`
      }
      if (imagePosition === 'right') {
        mobileQuery = `@media (max-width: 600px) {
              width: 15vw;
            }`
      }
      return mobileQuery

    case 'right':
      if (imagePosition === 'center') {
        mobileQuery = `@media (max-width: 600px) {
          width: 15vw;
        }`
      }
      if (imagePosition === 'right') {
        mobileQuery = `@media (max-width: 600px) {
            width: 70vw;
          }`
      }

      return mobileQuery

    default:
      break
  }
}
